import tokens from './tokens';
import web3Provider from './web3-provider';
import contract from './contract';
import user from './user';
import balances from './balances';
import notifications from './notifications';
import modal from './modal';

export default {
  tokens,
  web3Provider,
  contract,
  user,
  balances,
  notifications,
  modal
};


// WEBPACK FOOTER //
// ./src/reducers/index.js